import { Modelo } from '@ext/index';
import * as Types from './Viajante.types';
import moment, { Moment } from 'moment';
import { isObject } from 'util';
import { Viajante } from '@/__env/lib/Ventas/Viajantes/Viajante.nav';
import { Articulo } from '@/__env/lib/Articulos';

export class IViajante extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Nombre: string = '';
    public Apellido: string = '';
    public Email: string = '';
    public Zonas: Zona[] = [];


    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.nombre = this.Nombre;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
        this.Apellido = !this.Json.apellido ? '' : this.Json.apellido;
        this.Email = !this.Json.email ? '' : this.Json.email;

        if ( this.Json.zonas )
            this.Zonas = this.Json.zonas.map( ( x: any ) => new Zona( x ) );

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IViajante )
    {
        this.Model = Model;
    }

    public Model: IViajante;
    public get Descripcion(): string
    {
        return ( this.Model.Nombre ? this.Model.Nombre : '' ) + ( this.Model.Apellido ? ' ' + this.Model.Apellido : '' );
    }
}

export class Zona extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Viajante: number;
    public Id: number;
    public Descripcion: string = '';

    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Viajante = !this.Json.viajante ? '' : this.Json.viajante;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;


        this.Existe = true;
        return this.Existe;
    }
}


export class IEstadisticaVentas extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Viajante: Viajante = new Viajante();
    public Mes: number = 0;
    public Ano: number = 0;
    public Porcentaje: number = 0;
    public Fecha: Moment;
    public Ventas: number = 0;

    public set(): boolean
    {
        this.Mes = this.Json.mes;
        this.Ano = this.Json.ano;
        this.Fecha = moment( `${this.Ano}-${this.Mes}-1` );
        this.Ventas = this.Json.ventas;
        this.Porcentaje = this.Json.porcentaje;
        if ( isObject( this.Json.viajante) )
        {
            this.Viajante = new Viajante( this.Json.viajante);
        }

        this.Existe = true;
        return this.Existe;
    }
}

export class IEstadisticaArticulos extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Articulo: Articulo = new Articulo();
    public Mes: number = 0;
    public Ano: number = 0;
    public Cantidad: number = 0;
    public Fecha: Moment;
    public Ventas: number = 0;

    public set(): boolean
    {
        this.Mes = this.Json.mes;
        this.Ano = this.Json.ano;
        this.Fecha = moment( `${this.Ano}-${this.Mes}-1` );
        this.Ventas = this.Json.ventas;
        this.Cantidad = this.Json.cantidad;

        this.Articulo = new Articulo( this.Json.articulo );
        this.Existe = true;
        return this.Existe;
    }
}